<template>
  <el-dialog
    v-el-drag-dialog
    :visible.sync="innerVisible"
    :title="$t('Message.EDIStatusChangeRecord')"
    :close-on-click-modal="false"
    class="app-main-inner"
  >
    <cargo-ag-grid
      :show-side-bar="false"
      :grid-options="gridOptions"
      :column-defs="columnDefs"
      :row-data="rowData"
      :style="{width:'100%',height:'450px'}"
      @gridReady="params=>gridApi=params.api"
    />
    <span slot="footer">
      <el-button @click="innerVisible=false">{{ $t('common.btn.close') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { ediUpdateLog } from '@/api/seaExport/seaExportJob'

export default {
  name: 'EdiStatusLogDialog',
  props: {
    visible: { type: Boolean, required: true },
    jobUuid: { type: String, required: true }
  },
  data() {
    return {
      innerVisible: false,
      gridOptions: {},
      gridParams: {},
      gridApi: {},
      columnDefs: [
        {
          headerName: this.$t('Message.FeedbackNode'),
          field: 'nodeCode',
          suppressMenu: true,
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_Status'),
          field: 'status',
          suppressMenu: true,
          width: 200
        }, {
          headerName: this.$t('CargoMsg.Cargo_Time'),
          field: 'time',
          suppressMenu: true,
          width: 200
        }
      ],
      sideBarDefs: { toolPanels: ['columns', 'filter'], visible: false },
      rowData: []
    }
  },
  watch: {
    visible(newVal) {
      this.innerVisible = newVal
      if (newVal) {
        this.toQuery()
      }
    },
    innerVisible(newVal) {
      if (!newVal) {
        this.rowData = []
      }
      this.$emit('update:visible', newVal)
    }
  },
  created() {
    if (this.visible) {
      this.innerVisible = true
      this.toQuery()
    }
  },
  methods: {
    toQuery() {
      if (!this.jobUuid) {
        this.$message.warning(this.$t('Message.BusinessCannotBeEmpty'))
        return
      }
      ediUpdateLog(this.jobUuid).then(res => {
        this.rowData = res.data
      })
    }
  }
}
</script>

<style>
</style>
